import { Component, input } from '@angular/core';

@Component({
  selector: 'ev-tooltip-simple',
  templateUrl: './ev-tooltip-simple.component.html',
  styleUrl: './ev-tooltip-simple.component.scss',
})
export class EvTooltipSimpleComponent {
  text = input.required<string>();
}
